module.exports = __webpack_public_path__ + "img/minecart.e2a54b96.svg";